import React from 'react';

class ModelName extends React.Component {

    getModelName() {
        let model = this.props.model;
        let modelOption = this.props.modelOption;
        try {
            model = model.split(',');
        } catch (error) {
            model = [model];
        }
        let modelName = '';
        modelOption.map((c) => {
            model.map((v) => {
                if (v == c.value) {
                    if (modelName == '') {
                        modelName = c.text;
                    }
                    else {
                        modelName = modelName+', '+c.text;
                    }
                }
            })
        }) 
        return modelName;
    }

    render() {
        let modelName = this.getModelName();
        return (
            <td>
                <b><u style={{color: '#11B2D2'}}>{modelName}</u></b>
            </td>
        );
    }
}

export default ModelName;
